require('./site.scss');
var packageJson = require('../package.json');

var allowRedirection = false;
var openIEAttention = function() {};
var $ = require('jquery');
window.$ = $; // branding uses $
function random4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); 
}
function asyncLocalStorageChange(token) {
    if (token) {

        replaceLocation(token.claims.cmpy);
        runApp(token, allowRedirection)
        $('#tenant').val(token.claims.cmpy);

    } else {
        LoginForm.show();
    }
}

function getQsByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var LoginForm = (function () {
    var company = $('#tenant'),
        userName = $('#user_id'),
        pwd = $('#passwordInput'),
        code = $('#codeInput'),
        newPwd = $('#new_password'),
        content = $('.content'),
        forgotPasswordPopup = $('#forgotPassword'),
        forgotPasswordLink = $('.forgot-password'),
        sessionid = "",
        textRequestCode = "A password reset code has been sent to you.<br><br>Please wait for the reset code then click continue.<br><br>",
        textPasswordChanged = "Your password has been reset. You will now<br><br>be required to login with your new password.<br><br>",
        confirmPwd = $('#confirm_password'),
        errorMsgDiv = $('#message-area'),
        tenantLoginDetails = null,
        allInputs = $('#login input'),
        allPasswords = $('#passwordInput, #new_password, #confirm_password, #codeInput'),
        currentPasswordPolicies = {},
        policiesContainer = document.querySelector('.password-policies_container'),
        policiesCharacters = document.querySelector('.password-policies_characters'),
        policiesUppercase = document.querySelector('.password-policies_uppercase'),
        policiesLowercase = document.querySelector('.password-policies_lowercase'),
        policiesNumbers = document.querySelector('.password-policies_numbers'),
        policiesSpecial = document.querySelector('.password-policies_special'),
        changePasswordButton = document.querySelector('.password-policies_change-password-btn'),
        loginButtonLabel = 'Login',
        passwordTooLong = false;

    function checkCapsLock(event) {
        removeErrors();
        if (event.getModifierState) {
            if (event.getModifierState("CapsLock")) {
                $('.caps-lock').removeClass('hide');
            } else {
                $('.caps-lock').addClass('hide');
            }
        }
    }

    function removeErrors() {
        errorMsgDiv.html('');
        $('.error').removeClass('error');
    }

    document.addEventListener('keydown', function(e) {
        checkCapsLock(e);
    });

    document.addEventListener('mousedown', function(e) {
        checkCapsLock(e);
    });

    function checkPolicies() {
        var newPasVal = newPwd.val();
        if (newPasVal) {
            policiesContainer.classList.remove('password-policies_hide-icons');
        } else {
            policiesContainer.classList.add('password-policies_hide-icons');
        }
        var changePasswordAllowed = true;
        if (newPasVal.length > 127) {
            changePasswordAllowed = false;
            if (!passwordTooLong) {
                passwordTooLong = true;
                showError("Password is too long");
                newPwd.addClass('error');
            }
        } else {
            if (passwordTooLong) {
                passwordTooLong = false;
                showError("Your password has expired and must be changed.");
            }
            if (newPasVal.length >= currentPasswordPolicies.minPasswordLength) {
                policiesCharacters.classList.add('check-success');
            } else {
                policiesCharacters.classList.remove('check-success');
                changePasswordAllowed = false;
            }
        }

        var reg = /([A-Z])/g;
        if (!currentPasswordPolicies.minNumberUppercase ||
                (newPasVal.match(reg) && newPasVal.match(reg).length >= currentPasswordPolicies.minNumberUppercase)) {
            policiesUppercase.classList.add('check-success');
        } else {
            policiesUppercase.classList.remove('check-success');
            changePasswordAllowed = false;
        }

        reg = /([a-z])/g;
        if (!currentPasswordPolicies.minNumberLowercase ||
                (newPasVal.match(reg) && newPasVal.match(reg).length >= currentPasswordPolicies.minNumberLowercase)) {
            policiesLowercase.classList.add('check-success');
        } else {
            policiesLowercase.classList.remove('check-success');
            changePasswordAllowed = false;
        }

        reg = /\d/g;
        if (!currentPasswordPolicies.minNumberDigits ||
                (newPasVal.match(reg) && newPasVal.match(reg).length >= currentPasswordPolicies.minNumberDigits)) {
            policiesNumbers.classList.add('check-success');
        } else {
            policiesNumbers.classList.remove('check-success');
            changePasswordAllowed = false;
        }

        reg = /([!-\/:-@[-`{-~])/g;
        if (!currentPasswordPolicies.minNonAlphaNumeric ||
                (newPasVal.match(reg) && newPasVal.match(reg).length >= currentPasswordPolicies.minNonAlphaNumeric)) {
            policiesSpecial.classList.add('check-success');
        } else {
            policiesSpecial.classList.remove('check-success');
            changePasswordAllowed = false;
        }
        changePasswordButton.disabled = !changePasswordAllowed;
    }

    newPwd.on('input', function() {
        checkPolicies();
    });

    newPwd.on('keyup', function() {
        checkPolicies();
    });

    $('#login').submit(function () {
        if (tenantLoginDetails) {
            proceedSubmit();
        } else {
            var tenantLoginOption = checkTenantLoginOption();
            if (!tenantLoginOption) {
                return;
            }
            tenantLoginOption.then(proceedSubmit);
        }
    });

    function pluralize(amount, singular, plural) {
        if (amount == 1) return singular;
        if (plural) return plural;
        return singular + "s";
    }

    function proceedSubmit() {
        if (content.hasClass('waiting-validation-code')) {
            if (!code.val()) {
                showError("Reset code is required.");
                code.addClass('error');
                return;
            }
            var data = {
                company: company.val(),
                username: userName.val(),
                sessionid: sessionid,
                resetCode: code.val().replace(/[\-]/g, '')
            }
            var req = {
                method: 'POST',
                url: '/auth/resetValidation',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Accept': 'application/json'
                },
                data: JSON.stringify(data)
            };

            $.ajax(req).then(function (data) {
                currentPasswordPolicies = data && data.password_policy;

                if (!currentPasswordPolicies) {
                    showError("The reset code entered is incorrect");
                    code.addClass('error');
                    return;
                }
                fillPolicies(currentPasswordPolicies);
                $('.password-code-container').addClass("disabled-fields");
                switchDisableNewPass(false);
                code.prop( "disabled", true );
                content.removeClass('waiting-validation-code').addClass('require-change-password');
                $('.info-msg').html('');
            }, function (e) {
                showError("The reset code entered is incorrect");
                code.addClass('error');
            });
        } else if (tenantLoginDetails.href) {
            function continueRedirection() {
                var companyVal = company.val();
                replaceLocation(companyVal);
                var address = {company: companyVal};
                if (PageApp.redirectUri) {
                    address.redirect_uri = PageApp.redirectUri;
                } else {
                    address.home_uri = window.location.pathname;
                }

                // redirect the top window as an external authentication may not work in an iframe
                // later we can try to open it in a popup window if we can detect a popup blocker
                window.location.replace(tenantLoginDetails.href
                    + '&redirect_uri=' + encodeURIComponent(window.location.protocol + '//'
                                                            + window.location.host + "/openid")
                    + '&state=' + encodeURIComponent(JSON.stringify(address)));
            }
            if (/Trident.*rv:/.test(navigator.userAgent)) {
                openIEAttention().then(function() {
                    continueRedirection();
                })
            } else {
                continueRedirection();
            }
        }
        else if (validateForm()) {
            removeErrors()
            switchDisable(allInputs, true);
            var formData = getFormData();
            if (requireChangePwd()) {
                if (validationInProcess()) {
                    $('.info-msg').html('');
                    var data = {
                        company: company.val(),
                        username: userName.val(),
                        password: newPwd.val(),
                        sessionid: sessionid,
                        resetCode: code.val().replace(/[\-]/g, '')
                    }
                    var req = {
                        method: 'POST',
                        url: '/auth/resetPassword',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'Accept': 'application/json'
                        },
                        data: JSON.stringify(data)
                    };
                    $.ajax(req).then(function (data) {
                        $('.forgot-password__content-text').html(textPasswordChanged);
                        forgotPasswordPopup.addClass('password-changed').removeClass('hide');
                    }, function (response) {
                        showAuthError(response);
                        switchDisable(allInputs, false);
                        return;
                    });
                } else {
                    pcpAuth.changePassword(formData.password, formData.new_password, formData.tenant, formData.user_id)
                        .then(function (data) {
                            removeNewPasswordClass();
                            runAuth();
                        }, function (response) {
                            $('#message-area').html('');
                            showAuthError(response);
                            switchDisable(allInputs, false);
                            return;
                        });
                }
            } else {
                runAuth();
            }
            function runAuth() {
                allowRedirection = true;
                pcpAuth.requestNewToken({grant_type: 'password',
                                         company: formData.tenant,
                                         username: formData.user_id,
                                         password: formData.new_password ? formData.new_password : formData.password})
                    .then(function (token) {
                        pwd.val('');
                        switchDisable(allInputs, false);
                    }, function(data) {
                        switchDisable(allInputs, false);
                        if (data.responseJSON && data.responseJSON.password_policy) {
                            currentPasswordPolicies = data.responseJSON.password_policy;
                            fillPolicies(currentPasswordPolicies);
                            changePasswordButton.disabled = true;
                        }
                        showAuthError(data);
                    }).then(function() {
                        allowRedirection = false;
                    });
            }
        }
    }

    function fillPolicies(passwordPolicies) {
        $('.password-policies_characters .policy-value').text(passwordPolicies.minPasswordLength);
        $('.password-policies_uppercase .policy-value').text(passwordPolicies.minNumberUppercase);
        $('.password-policies_lowercase .policy-value').text(passwordPolicies.minNumberLowercase);
        $('.password-policies_numbers .policy-value').text(passwordPolicies.minNumberDigits);
        $('.password-policies_special .policy-value').text(passwordPolicies.minNonAlphaNumeric);
        $('.password-policies_characters .policy-measure').text(pluralize(passwordPolicies.minPasswordLength, " character"));
        $('.password-policies_uppercase .policy-measure').text(" uppercase" + pluralize(passwordPolicies.minNumberUppercase, " letter"));
        $('.password-policies_lowercase .policy-measure').text(" lowercase" + pluralize(passwordPolicies.minNumberLowercase, " letter"));
        $('.password-policies_numbers .policy-measure').text(pluralize(passwordPolicies.minNumberDigits, " number"));
        $('.password-policies_special .policy-measure').text(" special" + pluralize(passwordPolicies.minNonAlphaNumeric, " character"));

        checkPolicies();
    }

    function switchDisable(inputs, disable) {
        inputs.each(function(i, input) {
            input.disabled = disable;
        });
        $('.login-btn').val(disable ? 'Logging in...' : loginButtonLabel);
    }

    function generateSessionID() {
        return (random4() + random4() + "-" + random4() + "-4" + random4().substr(0,3) + "-" + random4() + "-" + random4() + random4() + random4()).toLowerCase();
    }

    $(".forgot-password__ok").click(function() {
        $('.disabled-fields').removeClass("disabled-fields");
        $('.forgot-password__content-text').html(textRequestCode);
        forgotPasswordPopup.addClass('hide').removeClass('password-changed');
        removeNewPasswordClass();
        resetLoginForm();
        switchDisable(allInputs, false);
        pwd.val('');
    });

    $(".forgot-password-link").click(function() {
        resetLoginForm();
        var companyVal = company.val();
        var userNameVal = userName.val();
        if (!companyVal || !userNameVal) {
            showError("The company and username are required</br>if you forgot your password");
            if (!companyVal) {
                company.addClass('error');
            }
            if (!userNameVal) {
                userName.addClass('error');
            }
            return;
        }

        sessionid = generateSessionID();

        var data = {
            company: companyVal,
            username: userNameVal,
            sessionid: sessionid
        }

        var req = {
            method: 'POST',
            url: '/auth/resetRequest',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Accept': 'application/json'
            },
            data: JSON.stringify(data)
        };

        $.ajax(req).then(function (data) {
            $('.forgot-password__content-text').html(textRequestCode);
            forgotPasswordPopup.removeClass('hide');
        }, function () {
            showError("Cannot reset password.");
        });
    });

    $('.forgot-password__continue').click(function() {
        content.addClass('code-validation').addClass('waiting-validation-code');
        resetLoginForm();
        switchDisableNewPass(true);
        $('#password-label').html('One-time reset code');
        forgotPasswordPopup.addClass('hide');
        code.val('');
        newPwd.val('');
        confirmPwd.val('');
    });

    function switchDisableNewPass(disable) {
        newPwd.prop("disabled", disable);
        confirmPwd.prop("disabled", disable);
        if (disable) {
            $('.login-change-password').addClass("disabled-fields");
        } else {
            $('.login-change-password').removeClass("disabled-fields");
        }
    }

    $('.forgot-password__close').click(function() {
        forgotPasswordPopup.addClass('hide');
    });

    $(".cancel-btn").click(function () {
        $('.password-code-container').removeClass("disabled-fields");
        switchDisableNewPass(false);
        code.prop("disabled", false );
        $('#password-label').html('Password');
        content.removeClass('waiting-validation-code').removeClass('require-change-password').removeClass('code-validation');
        resetLoginForm();
    });

    company.on('blur', function () {
        if (tenantLoginDetails) return;

        resetLoginForm();
        checkTenantLoginOption();
    });

    code.on('keydown', function(event) {
        var key = event.keyCode || event.charCode;
        var cursorPosition = code[0].selectionEnd;
        if (key == 8) {
            if (cursorPosition == 5 || cursorPosition == 10) {
                code[0].selectionEnd = cursorPosition - 1;
            }
        } else if (key == 46) {
            if (cursorPosition == 4 || cursorPosition == 9) {
                code[0].selectionEnd = code[0].selectionEnd + 2;
            }
        }
    });

    code.on('input', function(e) {
        var cursorPosition = code[0].selectionEnd;
        var originalValue = code.val();
        var codeOnly = originalValue.replace(/[\-]/g, '');
        var cleanedCode = codeOnly.replace(/[^a-zA-Z0-9]/g, '');
        var denyedSymbolsAmount = codeOnly.length - cleanedCode.length;
        if (!cleanedCode) {
            code.val("");
            return;
        }
        var valueToDisplay = cleanedCode.match(/.{1,4}/g).join('-').substr(0, 14);
        if (valueToDisplay.length == 4 || valueToDisplay.length == 9) {
            valueToDisplay = valueToDisplay + "-";
            cursorPosition = cursorPosition + 1;
        }
        code.val(valueToDisplay);


        // input had denied symbols
        if (denyedSymbolsAmount) {
            // shouldn't change position of cursor as these symbols will be removed
            cursorPosition = cursorPosition - denyedSymbolsAmount;
        }

        // cursor located before dashes
        if ((cursorPosition == 5 || cursorPosition == 10)) {
            cursorPosition = cursorPosition + 1;
        }

        // set cursor
        code[0].setSelectionRange(cursorPosition, cursorPosition);
    });

    allInputs.on('keydown', function(e) {
        if (!e.shiftKey && e.which != 13 && !requireChangePwd()) {
            resetLoginForm();
        }
    });

    userName.on('keydown', function() {
        removeNewPasswordClass();
    });
    company.on('input', function() {
        loginButtonLabel = 'Login';
        forgotPasswordLink.removeClass("hide");
        removeNewPasswordClass();
        if (tenantLoginDetails) {
            tenantLoginDetails = null;
            $('.login-btn').val('Login');
            $('#login').removeClass('open-id');
        }
    });

    function removeNewPasswordClass() {
        content.removeClass('waiting-validation-code').removeClass('require-change-password').removeClass('code-validation');
        $('#password-label').html('Password');
        newPwd.val('');
        confirmPwd.val('');
    }

    function checkTenantLoginOption() {
        var companyVal = company.val();
        if (!companyVal) {
            company.select();
            return;
        }

        var req = {
            method: 'GET',
            url: '/auth/company/' + companyVal,
            headers: {
                'Accept': 'application/vnd.premier.v1.hal+json'
            }
        };

        return $.ajax(req).then(function (data) {
            if (companyVal != company.val()) {
                return;
            }
            if (typeof data == 'string') {
                try {
                    data = JSON.parse(data);
                } catch (exception) {
                    console.error('Unknown format of tenant details returned from server : ' + data);
                    tenantLoginDetails = {};
                    return;
                }
            }

            var auth = data._links && data._links.auth;
            if (!auth) {
                forgotPasswordLink.removeClass("hide");
                $('.login-btn').val('Login');
                $('#login').removeClass('open-id');
                tenantLoginDetails = {};
                return;
            }
            forgotPasswordLink.addClass("hide");
            loginButtonLabel = (auth && auth.loginButtonLabel) ? auth.loginButtonLabel : 'Login';
            pwd.val('');
            $('.login-btn').val(loginButtonLabel);
            $('#login').addClass('open-id');
            company.select();

            tenantLoginDetails = auth;
        }, function () {
            if (companyVal != company.val()) {
                return;
            }
            $('.login-btn').val('Login');
            $('#login').removeClass('open-id');
            tenantLoginDetails = {};
            if (!userName.val()) userName.select();
            else pwd.select();
        });
    }

    function validateForm() {
        return (requireChangePwd() && inputValid(newPwd, "New Password") && inputValid(confirmPwd, "Confirm Password") && passwordsMatch()) ||
               (!requireChangePwd() && inputValid(company, "Company") && inputValid(userName, "Username") && inputValid(pwd, "Password"));
    }

    function passwordsMatch() {
        if (newPwd.val() === confirmPwd.val()) return true;

        showError("New passwords do not match");
        confirmPwd.addClass('error');
        newPwd.addClass('error');
        return false;
    }

    function resetLoginForm() {
        if (validationInProcess()) {
            $('.info-msg').html('Please enter the reset code provided');
        } else if (requireChangePwd()) {
            $('.info-msg').html('');
        } else {
            $('.info-msg').html('Please enter your login details');
            if (!$('#login').hasClass('open-id')) {
                forgotPasswordLink.removeClass('hide');
            }
        }
        removeErrors();
    }

    function requireChangePwd() {
        return content.hasClass('require-change-password');
    }

    function validationInProcess() {
        return content.hasClass('code-validation');
    }

    function inputValid($ele, inputName) {
        if (!$ele.val()) {
            showError(inputName + ' is required.');
            $ele.addClass('error');
            return false;
        }
        else {
            $ele.removeClass('error');
            return true;
        }
    }

    function showError(msg) {
        removeErrors();
        $('fieldset').addClass('error');
        var li = '<li>' + msg + '</li>';
        $('#message-area').append(li);
    }

    function getFormData() {
        var obj = {};
        obj[company.attr('name')] = company.val();
        obj[userName.attr('name')] = userName.val();
        obj[pwd.attr('name')] = pwd.val();

        if (requireChangePwd()) {
            obj[newPwd.attr('name')] = newPwd.val();
            obj[confirmPwd.attr('name')] = confirmPwd.val();
        }

        return obj;
    }

    function showAuthError(response) {
        var errorMessage = "Your account is currently unavailable. Please contact your administrator.";
        if (response.responseText) {
            var errorObject = JSON.parse(response.responseText);
            if (validationInProcess()) {
                switch (errorObject.error) {
                    case 'invalidCredentials':
                        errorMessage = 'The company, username or reset code are invalid. Please try again.';
                        break;
                    case 'cannot_reset':
                        errorMessage = 'Your password cannot be reset. Please contact your administrator.';
                        break;
                    case 'constraintViolation':
                        errorMessage = 'The new password does not meet the length, complexity, or history requirements.';
                        break;
                    case 'unable_to_reset':
                        errorMessage = 'Please try again and contact the Service Desk if the problem persists.';
                }
            } else {
                switch (errorObject.error) {
                    case 'invalidCredentials':
                    case 'invalidCompany':
                        company.addClass('error');
                        userName.addClass('error');
                        pwd.addClass('error');
                        errorMessage = 'The company, username or password are invalid.';
                        break;
                    case 'passwordExpired':
                        content.removeClass('code-validation').removeClass('waiting-validation-code').addClass('require-change-password');
                        resetLoginForm();
                        forgotPasswordLink.addClass("hide");
                        $('#password-label').html('Current password');
                        errorMessage = 'Your password has expired and must be changed.';
                        break;
                    case 'insufficientLicenses':
                        errorMessage = 'The maximum concurrent user limit for your licence has been reached. Please contact your administrator.';
                        break;
                    case 'locked':
                        errorMessage = 'Your account is locked. Please contact your administrator.';
                        break;
                    case 'disabled':
                        errorMessage = 'Your account is disabled. Please contact your administrator.';
                        break;
                    case 'int_authenticator_error':
                    case 'ext_authenticator_error':
                        errorMessage = 'Your login details cannot be verified at this time. Please contact your administrator.';
                        break;
                    case 'account_expired':
                        errorMessage = 'Your account has expired and can no longer be used.';
                        break;
                    case 'user_licence_invalid':
                        errorMessage = 'Your licence is no longer active or has expired.';
                        break;
                    case 'not_in_login_schedule':
                    case 'internal_login_schedule_error':
                        errorMessage = 'Login is denied as it is currently outside the schedule permitted for your account. ';
                        break;
                    case 'source_ip_addr_not_permitted':
                        errorMessage = 'Login from your current location is not permitted.';
                        break;
                }
            }
        } else if (typeof response == "string") {
            errorMessage = response;
        }
        showError(errorMessage);
    }

    return {
        show: function () {
            resetLoginForm();
            $('body').removeClass().addClass('login');
            $('.apps').removeClass('show-admin-links').removeClass('show-ad-links');
            document.querySelector('.background-image').style['display'] = 'block';
            document.querySelector('.apps-view-background-image').classList.remove('active');

            if (!company.val()) {
                company.val(getQsByName('company'));
            }

            checkTenantLoginOption();

            switch (getQsByName('error')) {
            case '':
            case null:
            case undefined:
                break;

            case 'expired':
                showError('Your session has expired, please log in to continue.');
                break;

            case 'configuration_error':
                showError('Tenancy is not fully provisioned. Please report to your administrator.');
                break;

            case 'email_notfound':
                showError('The user is not configured to access the platform. Please report to your administrator.');
                break;

            case 'email_misused':
                showError('The user is mapped to multiple records. Please report to your administrator.');
                break;

            case 'insufficientLicenses':
                showError('The number of concurrent users has been reached. Please contact your administrator.');
                break;

            case 'access_denied':
                showError('You must allow this application to access your profile information in order to login.');
                break;

            case 'authentication_error':
                showError('Failed to authenticate. Please try again later.');
                break;

            default:
                showError('Unexpected error. Please try again later or report to your administrator.');
                break;
            }

        },
        showAuthError: function (response) {
            return showAuthError(response);
        }
    };
})();

var UserApps = (function () {
    var apps = {};
    var htmlContentPrevious = "";
    apps.render = function (data, token) {
        data = typeof data == 'string' ? JSON.parse(data) : data;
        // Init background image by fetching Admin UI header footer
        var appsBackgroundImage = document.querySelector('.apps-view-background-image');
        UniTopbar.fetchBranding(pcpAuth, token.claims.tnt)
        .then(function(brandingStructure) {
            if (brandingStructure.background && brandingStructure.background.encodedImage) {
                appsBackgroundImage.style['background-image'] = 'url(' + brandingStructure.background.encodedImage + ')';
            }
        }, function() {
            // ignore the error and show applications
        }).then(function() {
            appsBackgroundImage.classList.add('active');
            $('body').removeClass().addClass('apps-view');
        });

        var basicLinks = '<nav class="basic-links' + (($('.apps').hasClass('show-admin-links') || $('.apps').hasClass('show-ad-links') )? ' invisible"' : '"')
            + '>' + generateLinksHtml(data.basic) + '</nav>';
        var adminLinks = '<nav class="admin-links' + ($('.apps').hasClass('show-admin-links') ? '"' : ' invisible"')
            + '>' + generateLinksHtml(data.admin) + '</nav>';
        var adLinks = '<nav class="ad-links' + ($('.apps').hasClass('show-ad-links') ? '"' : ' invisible"')
            + '>' + generateLinksHtml(data.ad) + '</nav>';

        if (htmlContentPrevious === (basicLinks + adminLinks + adLinks)) {
            return;
        }

        htmlContentPrevious = (basicLinks + adminLinks + adLinks);
        $('.apps-blocks').html(htmlContentPrevious);
        var adminLink = document.querySelector('#admin');
        basicLinks =  $('.basic-links');
        if (adminLink) {//if adminstration's disabled, link will not be found.
            adminLinks =  $('.admin-links');
            adminLink.addEventListener('click', function (event) {
                $('.apps').addClass('show-admin-links');
                adminLinks.removeClass('invisible');
            });
            document.getElementsByClassName("basic-links")[0].addEventListener("transitionend", function() {
                if ($('.apps').hasClass('show-admin-links')) {
                    basicLinks.addClass('invisible');
                } else {
                    adminLinks.addClass('invisible');
                }
            });
        }
        var adLink = document.querySelector('#ad');
        if (adLink) {//if no ad scopes, link will not be found.
            adLinks =  $('.ad-links');
            adLink.addEventListener('click', function (event) {
                $('.apps').addClass('show-ad-links');
                adLinks.removeClass('invisible');
            });
            document.getElementsByClassName("basic-links")[0].addEventListener("transitionend", function() {
                if ($('.apps').hasClass('show-ad-links')) {
                    basicLinks.addClass('invisible');
                } else {
                    adLinks.addClass('invisible');
                }
            });
        }
    };

    function generateLinksHtml(links) {
        var html = '';
        links.forEach(function (link) {
            html += '<div class="app-icon"'
             + (link.path ? ' onclick="window.open(\'' + link.path + '\')"' : ' id=' + link.id)
             + '><img src="' + getImgFromHomeDir(link.icon) + '" /><span>' + link.title + '</span></div>';
        });
        return html;

        function getImgFromHomeDir(imgUrl) {
            return imgUrl.indexOf('/img/') == 0? imgUrl.replace(/\/img\//g, '/home/images/') : imgUrl;
        }
    }

    return apps;
})();

var PageApp = {
    redirectUri: getQsByName('redirect_uri'),

    run: function (applications, token) {
        UserApps.render(applications, token);
    }
};

function logoutCallback() {
    pcpAuth.dispose();
}

var topbarMethods = UniTopbar.unifiedTopbarMethods({
    $:$,
    notifyToken: asyncLocalStorageChange,
    loginOpts: 'disable'
}, {
    aboutVersion: "Version " + packageJson.version,
    aboutIcon: "/home/images/main-menu.svg",
    aboutTitle: "Main Menu",
    logoutCallback: logoutCallback
});

topbarMethods.componentPromise.then(function(result) {
    openIEAttention = function() {
        return result.openNotification("ATTENTION", "/home/images/attention.svg",
                                       "Our system is designed to use the most up-to-date modern\
                                       web standards and has detected that you are using Internet\
                                       Explorer.<br><br>Microsoft has recommended that Internet\
                                       Explorer only be used as a compatibility solution for enterprises to\
                                       deal with legacy sites.<br><br>For a better and more secure experience\
                                       we recommend that you use a more modern browser.");
    };
});

var pcpAuth = topbarMethods.auth;

$('.angle').click(function () {
    $('.basic-links').removeClass('invisible');
    if ($('.apps').hasClass('show-admin-links')) {
        $('.ad-links').addClass('invisible');
    }
    if ($('.apps').hasClass('show-ad-links')) {
        $('.admin-links').addClass('invisible');
    }
    $('.apps').removeClass('show-admin-links').removeClass('show-ad-links');
});

function formIconsData(scopes) {
    var obj = {
       agent_desktop_group:
        {title: "Agent Desktop",
         id: "ad",
         icon: "/img/menu/agent-desktop.png"},
       agent_desktop:
        {title: "Agent Desktop",
         path: "/agent-desktop/",
         icon: "/img/menu/agent-desktop.png",
         onlyIcon: "/img/menu/agent-desktop.png"},
       agent_desktop_voice:
        {title: "Voice",
         path: "/voice-agent-desktop/",
         icon: "/img/menu/voice-agent-desktop.png",
         onlyIcon: "/img/menu/voice-agent-desktop.png"},
       agent_desktop_email:
        {title: "Email",
         path: "/email-agent-desktop/",
         icon: "/img/menu/email-agent-desktop.png",
         onlyIcon: "/img/menu/green-email-agent-desktop.png"},
       agent_desktop_chat:
        {title: "Chat",
         path: "/chat-agent-desktop/",
         icon: "/img/menu/chat-agent-desktop.png",
         onlyIcon: "/img/menu/green-chat-agent-desktop.png"},
       agent_desktop_sms:
        {title: "SMS",
         path: "/sms-agent-desktop/",
         icon: "/img/menu/sms-agent-desktop.png",
         onlyIcon: "/img/menu/green-sms-agent-desktop.png"},
       dashboard_w:
        {title: "Dashboard",
         path: "/dashboard/#/catalog/wallboard",
         icon: "/img/menu/dashboard.png"},
       dashboard_s:
        {title: "Dashboard",
         path: "/dashboard/#/catalog/supervisor",
         icon: "/img/menu/dashboard.png"},
       dashboard_a:
        {title: "Dashboard",
         path: "/dashboard/#/catalog/agent",
         icon: "/img/menu/dashboard.png"},
       bi_reports:
        {title: "Reports",
         path: "/bi-reports/",
         icon: "/img/menu/bi-reports.png"},
       voicemail_manager:
        {title: "Voicemail Manager",
         path: "/admin/",
         icon: "/img/menu/voicemail-manager.png"},
       administration:
        {title: "Administration",
         id: "admin",
         icon: "/img/menu/administration.png"},
       campaign_manager:
        {title: "User & Queue Administration",
         path: "/admin/",
         icon: "/img/menu/campaign-manager.png"},
       import_export_manager:
        {title: "Import/Export Manager",
         path: "/import-export/",
         icon: "/img/menu/import-export.png"},
       recording_manager:
        {title: "Recording Manager",
         path: "/recording-manager/",
         icon: "/img/menu/recordings-manager.png"},
       agent_monitoring:
        {title: "Agent Monitoring",
         path: "/monitor/",
         icon: "/img/menu/agent-monitoring.png"}};

    var setOfIcons = {basic:[],admin:[],ad:[]};

    function countOccurrences(regexp) {
        return Object.keys(scopes).filter(function(name) {return regexp.test(name)}).length
    }

//*** Agent Desktop
    if (scopes["ad:f"] || scopes["ad:vf"] || scopes["ad:ef"] || scopes["ad:cf"] || scopes["ad:sf"]) {
        setOfIcons.basic.push(obj.agent_desktop);
    }
//*** Dashboard
    if (scopes["db:w"]) {
        setOfIcons.basic.push(obj.dashboard_w);
    } else if (scopes["db:s"]) {
        setOfIcons.basic.push(obj.dashboard_s);
    } else if (scopes["db:a"]) {
        setOfIcons.basic.push(obj.dashboard_a);
    }
//*** Report Manager
    if (scopes["bi:"]) {
        setOfIcons.basic.push(obj.bi_reports);
    }
//*** User & Queue Administration
    if (scopes["adm:"] && (countOccurrences(/^adm:/) - countOccurrences(/^adm:vm\./) > 1)) {
        setOfIcons.admin.push(obj.campaign_manager);
    }
//*** Voice Mail Manager
    else if (countOccurrences(/^adm:vm\./)) {
        setOfIcons.basic.push(obj.voicemail_manager);
    }
//*** Import / Export Manager
    if (scopes["ie:"]) {
        setOfIcons.admin.push(obj.import_export_manager);
    }
//*** Recording Manager
    if (scopes["rm:"]) {
        setOfIcons.admin.push(obj.recording_manager);
    }
//*** Agent Monitoring
    if (scopes["am:"]) {
        setOfIcons.admin.push(obj.agent_monitoring);
    }
//*** Administration
    if (setOfIcons.admin.length) {
        setOfIcons.basic.push(obj.administration);
    }

    return setOfIcons;
}

(function() {
    var code = getQsByName('code');
    var state = getQsByName('state');

    if (code && state) {
        state = JSON.parse(state);


        // workaround https://bugzilla.mozilla.org/show_bug.cgi?id=1422334
        window.location.hash = window.location.hash;

        // As OpenID query parameters are present in the address bar, page refresh or
        // navigation to this address through history, would cause a new attempt
        // to obtain authorization which would fail if it was already obtained.
        // To prevent that the current query parameters must be replaced.

        return pcpAuth.requestNewToken({grant_type: 'urn:pcp/openid',
                                        company: state.company,
                                        code: code})
            .then(function(token) {
                if (state.redirect_uri) {
                    window.location.replace(state.redirect_uri);
                    return;
                }

                if (!replaceLocation(state.company, state.home_uri)) {
                    PageApp.redirectUri = null;
                    runApp(token, true);
                }
            }, function(error) {
                replaceLocation(state.company);
                if (!PageApp.redirectUri && state.redirect_uri) {
                    PageApp.redirectUri = state.redirect_uri;
                }
                LoginForm.show();
                LoginForm.showAuthError(error);
            });
    }
    // On a page refresh or back navigation switch to the first line of main menu
    window.addEventListener("pageshow", function(event) {
        $('.basic-links').removeClass('invisible');
        $('.admin-links').addClass('invisible');
        $('.ad-links').addClass('invisible');
        $('.apps').removeClass('show-admin-links').removeClass('show-ad-links');
    });
})();

function replaceLocation(company, url) {
    if (!window.history || !window.history.replaceState) {
        return;
    }

    // if the company is passed, use it, otherwise take it from the query string
    var qs;
    if (!company) {
        var match = window.location.search.match('[?&](company=[^&]*)');
        qs = match ? '?' + match[1] : '';
    } else {
        qs = '?company=' + company;
    }
    window.history.replaceState(null, document.title, (url || '') + qs);
}

function runApp(token, allowRedirect) {
    if ($('body').hasClass('login') && /Trident.*rv:/.test(navigator.userAgent)) {
        openIEAttention().then(function() {
            continueRunningApp();
        })
    } else {
        continueRunningApp();
    }
    function continueRunningApp() {
        // redirect to the previous application address possibly with some state
        if (PageApp.redirectUri) {
            window.location.replace(PageApp.redirectUri);
            return;
        }

        // redirect to the only application available to the user
        // there're none of second level elements or one admin element or one AD element.
        var applications = formIconsData(token.scopes);

        if (allowRedirect && applications.basic.length == 1 && (applications.admin.length + applications.ad.length < 2)) {
            var newLocation;
            if (applications.admin.length) {
                newLocation = applications.admin[0].path;
            } else if (applications.ad.length) {
                newLocation = applications.ad[0].path;
            } else {
                newLocation = applications.basic[0].path;
            }
            window.location = newLocation;
            return;
        }

        $('.content').removeClass('require-change-password');
        $('#password-label').html('Password');
        PageApp.run(applications, token);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 26
// module chunks = 1